export default __webpack_public_path__ + "static/media/cross.38cce37e.svg";